import './GlobeVisual.css';
import './HeroOrbitMotion.css';

const globeImageUrl = 'https://media-manager-c.questera.ai/greta-media/46a9e1323b5c997de8c3ebac6eb3f9d74ccd00e463a5744676fe05afae233bf74d2b422fbe3649d2b4b7a9fc91fa3904/images/aW1hZ2UvcG5n/191a6a0ac299ba660016afbf97ce4746.png';

export default function GlobeVisual() {
  return (
    <div className="global-globe" aria-label="ProfitYo Global globe">
      <div className="global-globe-shell">
        <img
          className="global-globe-image"
          src={globeImageUrl}
          alt="ProfitYo Global"
        />
      </div>
    </div>
  );
}